// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// optional (only if you really use analytics)
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAoGH3i_TmufGF2Mg2GTwbhGvO4XFOJIRc",
  authDomain: "portfoliowebsite-c5a49.firebaseapp.com",
  projectId: "portfoliowebsite-c5a49",

  // 🔥 FIXED (important)
  storageBucket: "portfoliowebsite-c5a49.firebasestorage.app",

  messagingSenderId: "786281573037",
  appId: "1:786281573037:web:6cba53977b38b4fb103424",
  measurementId: "G-T8GDF8SWK0"
};

const app = initializeApp(firebaseConfig);

// ✅ SERVICES
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// optional
// export const analytics = getAnalytics(app);

export default app;